import { SELECTORS } from './selectors';

const $ = jQuery;

/**
 * Modal root
 * Use function (not cached) in case modal is re-rendered
 */
export function getModal() {
	return $(SELECTORS.modal);
}

export function getAllContexts() {
	const $modal = getModal();

	return $modal.find(SELECTORS.context);
}

/**
 * Get modal context
 * @param contextId
 */
export function getContext(contextId) {
	const $modal = getModal();

	const $context = $modal
		.find(`${SELECTORS.context}[data-id="${contextId}"]`)
		.first();

	return $context.length ? $context : $modal.find(SELECTORS.context).first();
}

/**
 * Active context inside modal
 * @param $modal
 */
export function getActiveContext($modal = getModal()) {
	return $modal.find(SELECTORS.contextActive);
}

/**
 * All condition rows
 * @param $context
 */
export function getConditionRows($context = getActiveContext()) {
	return $context.find(SELECTORS.row);
}

/**
 * First condition row (base row)
 * @param $context
 */
export function getFirstConditionRow($context = getActiveContext()) {
	return $context.find(SELECTORS.row).first();
}

/**
 * Elements inside a single condition row
 * @param $row
 */
export function getRowElements($row) {
	return {
		row: $row,
		type: $row.find(SELECTORS.conditionType),
		ids: $row.find(SELECTORS.conditionIds),
		idsWrap: $row.find(SELECTORS.conditionIdsWrap),
		idsLabel: $row.find(SELECTORS.conditionIdsLabel),
		duplicate: $row.find(SELECTORS.btnDuplicate),
		remove: $row.find(SELECTORS.btnRemove),
		actions: $row.find(SELECTORS.rowActions),
	};
}

/**
 * Modal fields
 * @param $context
 */
export function getModalFields($context) {
	return {
		hook: $context.find(SELECTORS.hook),
		hookName: $context.find(SELECTORS.hookName),
		priority: $context.find(SELECTORS.priority),
		skipConditions: $context.find(SELECTORS.skipConditions),
	};
}
